export const ElemSchema = () => ({
  title: "Element",
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['image', 'alt', 'link'],
    },
  ],

  properties: {  
    image: {
      title: 'Sponsor Image',
      widget: 'object_browser',
      mode: 'image',
      allowExternals: true,
      return: 'single',
    },
    alt: {
      title: 'Image Alt Text',
      type: 'string',
    },
    link: {
      title: "Link auf Sponsorwebsite",
      type: "String"
    },
  },
  required: [],
});

export const EditSchema = (intl) => ({
  title: "Schema",
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ["anzahl", "load", "usePath"],
    },
    {
      id: 'content',
      title: "Sonsor hinzu",
      fields: ['elems'],
    },
  ],

  properties: {
    anzahl: {
      title: "Anzahl pro Seite",
      type: "integer",
      default: 3
    },
    load: {
      title: "Lade aus Ordner",
      type: "String"
    },
    usePath: {
      title: "Nutze Pfad",
      type: "boolean"
    },
    elems: {
      title: "Elements",
      schema: ElemSchema(intl),
      widget: 'object_list',
    },
  },
  required: [],
});
